//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'InputText',
	props: {
		model: [Number, String],
		label: String,
		id: String,
		placeholder: String,
		disabled: Boolean,
		min: String,
		max: String,
		type: {
			type: String,
			default() {
				return 'text';
			},
		},
		errors: {
			type: Array,
			default() {
				return [];
			},
		},
		with_label: {
			type: Boolean,
			default() {
				return true;
			},
		},
	},
	data() {
		return {
			value: null,
		};
	},
	watch: {
		model: function (newValue) {
			this.value = newValue;
		},
	},
	computed: {
		state() {
			return this.errors == null || this.errors.length == 0 ? null : this.errors.length == 0;
		},
		invalidFeedback() {
			if (this.errors.length) {
				return this.errors[0];
			}
			return null;
		},
	},
	mounted() {
		if (this.model !== null) {
			this.value = this.model;
		}
	},
};
